import {
  type RelatedWidget,
  type StorefrontWidget,
  StorefrontWidgetTypeAll,
  type WidgetStaticPageCategory
} from 'ecosystem'
import { widgetApi } from '../storefront-api/widgetEndpoint'

// Extracted from ./store so that the pure factories there (categoryFactory,
// badgesFactory, deliveryFactory, isOdd, …) can be imported by client components
// without dragging in the storefront-api (and its server-only credentials store).
export async function staticPagesCategoryFactory(): Promise<RelatedWidget[]> {
  const widgets = (await widgetApi.getWidgets({
    view: 'STATIC_VIEWS',
    type: StorefrontWidgetTypeAll.WIDGET_STATIC_VIEW_CATEGORY,
    filter: {
      key: 'name',
      textValues: ['Static Pages']
    }
  })) as StorefrontWidget<WidgetStaticPageCategory>[]

  return widgets.length ? widgets[0].widget.relatedStaticPages : []
}
